package `data`.db.delight

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class WatchProgress(
  public val videoId: Long,
  public val imdbId: String?,
  public val isTvShow: Long,
  public val seasonNumber: Long,
  public val episodeNumber: Long,
  public val positionSec: Long,
  public val durationSec: Long,
  public val progress: Double,
  public val engagedSec: Long,
  public val status: String,
  public val title: String?,
  public val imageUrl: String?,
  public val backdropUrl: String?,
  public val hiddenFromContinue: Long,
  public val isDeleted: Long,
  public val changedAt: String,
  public val audio: String?,
  public val quality: String?,
  public val subtitles: String?,
)
